import { Routes } from '@angular/router';
import { AuthGuardService } from './core/providers/auth-guard.service';

export const routes: Routes = [
  {
    path: 'docs',
    pathMatch: 'full',
    loadComponent: () =>
      import('./shared/pages/docs-page/docs-page.component').then((m) => m.DocsPageComponent),
  },
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  {
    path: 'home',
    loadChildren: () => import('./features/campaign/campaign.routes').then((m) => m.HOME_ROUTES), canActivate: [AuthGuardService],
  },
  {
    path: 'details',
    loadChildren: () =>
      import('./features/campaign/campaign.routes').then((m) => m.DETAILS_ROUTES), canActivate: [AuthGuardService],
  },
  {
    path: 'admin',
    loadChildren: () => import('./features/admin/admin.routes').then((m) => m.ADMIN_ROUTES), canActivate: [AuthGuardService],
  },
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full',
  },
];
